export default __webpack_public_path__ + "static/media/Ramboll.f4faa4c2.png";